var styles = {"tooltipWrapper":"VDS__MON__tooltip-module__XqNcj","disabled":"VDS__MON__tooltip-module__ulX-t","customAnchorWrapper":"VDS__MON__tooltip-module__9C9Qf","showDialog":"VDS__MON__tooltip-module__4E27T","anchorWrapper":"VDS__MON__tooltip-module__cRO1J","anchorButtonWrapper":"VDS__MON__tooltip-module__JQOLC"};

export { styles as default };
